import React, { useState, useEffect, useMemo } from 'react';
import { Chart } from 'react-chartjs-2';
import Select from 'react-select';
import _ from 'lodash';
import { Card, CardHeader, CardBody, TabPane } from 'reactstrap';
import PieChart from 'components/PieChart';
import PageTabs from 'components/PageTabs';
import TightTable from 'components/TightTable';
import TightChart from 'components/TightChart';
import TimePeriod, { formatDates } from 'components/TimePeriod';
import LineChart from 'components/LineChart';
import { AutoColumns } from 'components/Columns';
import { useArrayState } from 'components/CustomHooks';
import { toDeci, toPerc, formatCurrency, toPercTable, toDeciTable } from 'helpers/formatter';
import { colors } from 'helpers/chart';
import { optionizeValue, optionizeAll, getValue, getDate } from 'helpers/select';
import { removeEmptyRows, toAggregatedDataFrame } from 'helpers/data-frame';
import { formatYearMonthToMonthYear } from 'helpers/date';
import Summary from './Summary';
import Holdings from './Holdings';

function SummaryBase({ data, params, notify, session }) {
  return (
    <>
      <PageTabs
        options={[
          { value: 'holdings', label: 'Holdings' },
          { value: 'summary', label: 'Summary' },
        ]}
        colorIndex={1}
      >
        <TabPane tabId="holdings" role="tabpanel">
          <Holdings data={data.details} params={params} />
        </TabPane>
        <TabPane tabId="summary" role="tabpanel">
          <Summary data={data.summary} params={params} />
        </TabPane>
      </PageTabs>
    </>
  );
}

export default SummaryBase;
